import { Component, OnInit, Injector } from '@angular/core';
import { MembersAthletesFiltersServiceService } from '../../../members/details-page/members-athletes/services/members-athletes-filters-service.service';
import { FilterAthletesService } from '../../services/filter-athletes.service';
import { BootstrapMembersAthletesComponent } from '../../../members/details-page/members-athletes/bootstrap-members-athletes/bootstrap-members-athletes.component';
import { MembersAthletesTableComponent } from 'src/app/members/details-page/members-athletes/bootstrap-members-athletes-table/bootstrap-members-athletes-table.component';
import { HttpClient } from '@angular/common/http';
import { mergeMap, map, combineLatest, filter, catchError } from 'rxjs/operators';
import { IFederationAthleteStore } from 'src/app/common-page-components/stores/entities-store/federation-athlete-store';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { environment } from '@environments/environment';
import { INews } from 'src/app/common-page-components/news-panel/news-panel.component';

@Component({
  selector: 'app-bootstrap-atheletes',
  templateUrl: './bootstrap-atheletes.component.html',
  styleUrls: ['./bootstrap-atheletes.component.scss'],
  providers: [
    { provide: MembersAthletesFiltersServiceService, useClass: FilterAthletesService }
  ]
})
export class BootstrapAtheletesComponent extends MembersAthletesTableComponent implements OnInit {

  /**
   * A news Array of athletes
   *
   * @type {Array<INews>}
   * @memberof BootstrapAtheletesComponent
   */
  news: Array<INews>;

  constructor(injector: Injector, router: Router, filter_service: MembersAthletesFiltersServiceService, http: HttpClient) {
    super(injector, router, filter_service, http);
    this.indexOfCategoryCombo = 2;
    this.ShowNoResultsBox = true;
    http.get(environment.news_api.athletes_spotligth).pipe(catchError(e => of([]))).subscribe((next: any) => {
      this.news = next as any;
    });
  }
  /**
   * Build headers of this page.
   *
   * The headers are different when isn't a selected category.
   */
  headers() {
    let headers = [
      { name: 'World Ranking', isSortable: true, sortProperty: 'RANKING' },
      { name: 'Name', isSortable: true, sortProperty: 'NAME' },
      { name: 'Country', isSortable: true, sortProperty: 'NOC' },
      { name: "Age", isSortable: true, sortProperty: 'AGE' },
    ];
    if (!this.categorySelected()) {
      headers = headers.concat([
        { name: 'Category', isSortable: false, sortProperty: '', classes: ['center-text'] } as any,
      ]);
    }
    else {
      headers = headers.concat([
        { name: 'Average Arrow', isSortable: true, sortProperty: 'ARROWAVG' },
        { name: 'Match Wins', isSortable: true, sortProperty: 'MATCHWIN' }
      ]) as any;
    }
    return headers;
  }
  ngOnInit() {
    this.filters_services.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]),
      map(([a, b]) => a), map(([order, text, category, active, countryCode]) => {
        this.currentCategory = category;
        const params = {
          CatId: category ? category.Id : undefined,
          Name: text.text,
          SortBy: order.sortingSend,
          Country: countryCode,
          Active: active.Name === 'All' ? 0 : active.Name === 'Current' ? 1 : -1
        };
        if (this.checkParamsForShowMessage(params) === false) {
          this.model.data = [];
          this.model.loadingRef = false;
          this.model.pagination.totalResults = 0;
          this.customLoadMsg = 'Search or filter by category or country to find athletes';
          this.ShowNoResultsBox = true;
        } else {
          this.ShowNoResultsBox = false;
          this.customLoadMsg = 'No results';
        }
        return params;
      }),
      filter(a => this.checkParamsForShowMessage(a)),
      mergeMap(params => this.model.requestData(params, this.request_more_data)
      )).subscribe();
    // Set all categories, keyed by category code so we can add behaviours when an athlete category
    // is selected.
    this.filter_service.filtersType[this.indexOfCategoryCombo].options.options_subject.asObservable().subscribe((categories) => {
      this.categories = {};
      for (var key in categories) {
        this.categories[categories[key].Code] = categories[key];
      }
    });
  }

  /**
   * A method for check if there's any correct param and send data.
   *
   * @param {*} params
   * @returns
   * @memberof BootstrapAtheletesComponent
   */
  checkParamsForShowMessage(params: any) {
    return params.CatId !== undefined || params.Country.toString().length > 0 || params.Name !== ''
  }

  /**
 * Method for get first country code of coache from NOC property
 *
 * @param {ICoaches} coache
 * @returns
 * @memberof BootstrapCoachesComponent
 */
  getCountryCode(athlete: IFederationAthleteStore) {
    return (athlete.NOC);
  }

  /**
   * Method for get the name of the country
   *
   * @param {string} NOC
   * @returns
   * @memberof BootstrapCoachesComponent
   */
  getCountryName(NOC: string) {
    return this.model.dependencies[0].entity.data.find(value => value.NOC === NOC).CShort;
  }


}
